import React from 'react';
import { useOutlet } from 'react-router-dom';
export const RenderSubRoutes = ({ children }) => {
    if (children) {
        return React.createElement(React.Fragment, null, children);
    }
    else {
        return useOutlet();
    }
};
//# sourceMappingURL=RenderSubRoutes.js.map